import { FilterComponent } from './tag/filters';
import InfinityScroll from '../components/infinityScroll';
import setTopBar from '../components/topBar.js';
import setCategoriesSlider from './tag/categories_slider.js';
import setFullbanner from './home/1_fullbanner';
import setMinibanner from './home/1_minibanner';

const Tag = {
  init: function () {
    setTopBar();
    setCategoriesSlider();
    FilterComponent.init();
    InfinityScroll.init();
    setFullbanner();
    setMinibanner();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Tag.init();
});


// Seleciona o botão e o container
const filterButton = document.querySelector('.filter-button');
const filterContainer = document.querySelector('.filter-container');

// Adiciona o evento de clique
filterButton.addEventListener('click', function() {
    // Alterna entre display none e block
    if (filterContainer.style.display === 'none' || filterContainer.style.display === '') {
        filterContainer.style.display = 'block';
    } else {
        filterContainer.style.display = 'none';
    }
});